import { useEffect, useState } from "react";
import { auth } from "config/firebase.js";
import { onAuthStateChanged } from "firebase/auth";

function useCurrentUser() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  return currentUser;
}

export default useCurrentUser;
